import {IsNaN} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React, {useMemo} from "react";
import {Button, CheckBox, Row, Spinner, Text} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {RunInAction, RunInAction_Set, useForceUpdate} from "web-vcore";
import {GetTestSegments} from "../../../../Server/DB/testSegments.js";
import {TestSegment} from "../../../../Server/DB/testSegments/@TestSegment.js";
import {GetUser} from "../../../../Server/DB/users.js";
import {store} from "../../../../Store/index.js";
import {UserPicker} from "../../../../Utils/ReactComponents/UserPicker.js";
import {TestResult} from "../../Processors/TestSegmentRunner.js";
import {TestSegmentUI} from "../TestingPanel/TestSegmentUI.js";

export const EyeMoveDetectionTab = observer_mgl(()=>{
	const forceUpdate = useForceUpdate();
	const self = useMemo(()=>({
		segmentResults: [] as TestResult[],
		OnTestResult: (result: TestResult, segment: TestSegment, index: number)=>{
			const uiState = store.main.testing;
			const segments = GetTestSegments(uiState.selectedUser);
			//const segment = segments[index];
			const enabledSegments = segments.filter(a=>a.enabled);
			const indexInEnabled = enabledSegments.indexOf(segment);

			self.segmentResults[indexInEnabled] = result;
			forceUpdate();

			const allTestsDone = self.segmentResults.filter(a=>a).length == enabledSegments.length;
			if (allTestsDone) { // only share segment test-results on store, once all have come in
				var averageScore = self.segmentResults.filter(a=>a).map(a=>a.score).Average();
				RunInAction("OnTestResult.allDone", ()=>uiState.averageTestScore = averageScore);
			} /*else if (uiState.averageTestScore != null) {
				RunInAction("OnTestResult.starting", ()=>uiState.averageTestScore = null);
			}*/
		},
	}), []);

	const uiState = store.main.testing;

	const selectedUser = GetUser(uiState.selectedUser);
	const segments = GetTestSegments(uiState.selectedUser).OrderByDescending(a=>a.startTime);
	self.segmentResults.length = segments.filter(a=>a.enabled).length; // keep segment-results array-length up-to-date
	if (self.segmentResults.length) {
		var averageScore = self.segmentResults.filter(a=>a).map(a=>a.score).Average();
	}

	return (
		<>
			<Row center>
				<Text>User:</Text>
				<UserPicker value={uiState.selectedUser} onChange={val=>RunInAction_Set(()=>uiState.selectedUser = val)}>
					<Button ml={5} p={5} style={{fontSize: 12}} text={uiState.selectedUser ? `${selectedUser?.displayName} (id: ${selectedUser?.id})` : "(click to select user)"}/>
				</UserPicker>
				<CheckBox ml={5} text="Run tests" value={uiState.runTests} onChange={val=>RunInAction_Set(()=>uiState.runTests = val)}/>
				{uiState.runTests && averageScore! != null && !IsNaN(averageScore) &&
				<Text ml={5}>Average score: {averageScore.ToPercentStr(.1)}</Text>}
			</Row>
			<Row mt={5} center>
				<Text>X-range:</Text>
				<Spinner ml={5} value={uiState.xRange} onChange={val=>RunInAction_Set(()=>uiState.xRange = val)}/>
				<Text ml={5}>Y-range:</Text>
				<Spinner ml={5} value={uiState.yRange} onChange={val=>RunInAction_Set(()=>uiState.yRange = val)}/>
				<Text ml={5}>False detection penalty:</Text>
				<Spinner ml={5} value={(uiState.falseDetectionPenalty * 100).RoundTo(1)} onChange={val=>RunInAction_Set(()=>uiState.falseDetectionPenalty = val / 100)}/>
				<Text>%</Text>
				{/*<CheckBox ml={5} text="Normalize" value={uiState.normalize} onChange={val=>RunInAction_Set(()=>uiState.normalize = val)}/>
				<InfoButton ml={5} text="Normalization settings are borrowed from the engine config's eeg section."/>
				<CheckBox ml={5} text="Smooth" value={uiState.smooth} onChange={val=>RunInAction_Set(()=>uiState.smooth = val)}/>
				<InfoButton ml={5} text="Smoothing settings are borrowed from the engine config's eeg section."/>*/}
				<CheckBox ml={5} text="Show detections" value={uiState.showDetections} onChange={val=>RunInAction_Set(()=>uiState.showDetections = val)}/>
			</Row>
			<Row mt={5}>Test segments:</Row>
			<ScrollView style={{marginTop: 5}} contentStyle={{paddingBottom: window.innerHeight - 200}}>
				{segments.map((segment, index)=>{
					return <TestSegmentUI key={segment.id} segment={segment} index={index} onTestResult={self.OnTestResult}/>;
				})}
			</ScrollView>
		</>
	);
});